import { render, staticRenderFns } from "./wings.vue?vue&type=template&id=d467b0fc&"
import script from "./wings.vue?vue&type=script&lang=js&"
export * from "./wings.vue?vue&type=script&lang=js&"
import style0 from "./wings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports